var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.resources,"disable-pagination":"","loading":_vm.isLoading,"hide-default-footer":"","hide-default-header":_vm.isMobile,"height":"300px","dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }